import competitionActionTypes from "./competitions.types";

export const createTournamentStart = (data) => ({
  type: competitionActionTypes.CREATE_TOURNAMENT_START,
  payload: data, // { token, tournamentData }
});

export const createTournamentSuccess = (tournament) => ({
  type: competitionActionTypes.CREATE_TOURNAMENT_SUCCESS,
  payload: tournament,
});

export const createTournamentFailure = (error) => ({
  type: competitionActionTypes.CREATE_TOURNAMENT_FAILURE,
  payload: error,
});

export const createChallengeStart = (data) => ({
  type: competitionActionTypes.CREATE_CHALLENGE_START,
  payload: data, // { token, challengeData }
});

export const createChallengeSuccess = (challenge) => ({
  type: competitionActionTypes.CREATE_CHALLENGE_SUCCESS,
  payload: challenge,
});

export const createChallengeFailure = (error) => ({
  type: competitionActionTypes.CREATE_CHALLENGE_FAILURE,
  payload: error,
});

export const createOneVOneStart = (data) => ({
  type: competitionActionTypes.CREATE_ONE_V_ONE_START,
  payload: data, // { token, oneVOneData }
});

export const createOneVOneSuccess = (oneVOne) => ({
  type: competitionActionTypes.CREATE_ONE_V_ONE_SUCCESS,
  payload: oneVOne,
});

export const createOneVOneFailure = (error) => ({
  type: competitionActionTypes.CREATE_ONE_V_ONE_FAILURE,
  payload: error,
});

export const fetchCompetitionDetailStart = (data) => ({
  type: competitionActionTypes.FETCH_COMPETITION_DETAIL_START,
  payload: data, // { token, type, id }
});

export const fetchCompetitionDetailSuccess = (competition) => ({
  type: competitionActionTypes.FETCH_COMPETITION_DETAIL_SUCCESS,
  payload: competition,
});

export const fetchCompetitionDetailFailure = (error) => ({
  type: competitionActionTypes.FETCH_COMPETITION_DETAIL_FAILURE,
  payload: error,
});

export const joinCompetitionStart = (data) => ({
  type: competitionActionTypes.JOIN_COMPETITION_START,
  payload: data, // { token, type, id }
});

export const joinCompetitionSuccess = (result) => ({
  type: competitionActionTypes.JOIN_COMPETITION_SUCCESS,
  payload: result,
});

export const joinCompetitionFailure = (error) => ({
  type: competitionActionTypes.JOIN_COMPETITION_FAILURE,
  payload: error,
});

export const fetchMyEventsStart = (token, page = 1, limit = 10) => ({
  type: competitionActionTypes.FETCH_MY_EVENTS_START,
  payload: { token, page, limit },
});

export const fetchMyEventsSuccess = (events) => ({
  type: competitionActionTypes.FETCH_MY_EVENTS_SUCCESS,
  payload: events, // { tournaments, challenges, oneVOnes, pagination }
});

export const fetchMyEventsFailure = (error) => ({
  type: competitionActionTypes.FETCH_MY_EVENTS_FAILURE,
  payload: error,
});

export const reportScoreStart = (data) => ({
  type: competitionActionTypes.REPORT_SCORE_START,
  payload: data, // { token, type, id, winnerId, score }
});

export const reportScoreSuccess = (result) => ({
  type: competitionActionTypes.REPORT_SCORE_SUCCESS,
  payload: result,
});

export const reportScoreFailure = (error) => ({
  type: competitionActionTypes.REPORT_SCORE_FAILURE,
  payload: error,
});

export const submitDisputeEvidenceStart = (data) => ({
  type: competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_START,
  payload: data, // { token, type, id, imageArray, textEvidence }
});

export const submitDisputeEvidenceSuccess = (result) => ({
  type: competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_SUCCESS,
  payload: result,
});

export const submitDisputeEvidenceFailure = (error) => ({
  type: competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_FAILURE,
  payload: error,
});

export const fetchPlatformsStart = (token) => ({
  type: competitionActionTypes.FETCH_PLATFORMS_START,
  payload: token,
});

export const fetchPlatformsSuccess = (platforms) => ({
  type: competitionActionTypes.FETCH_PLATFORMS_SUCCESS,
  payload: platforms,
});

export const fetchPlatformsFailure = (error) => ({
  type: competitionActionTypes.FETCH_PLATFORMS_FAILURE,
  payload: error,
});

export const fetchCategoriesStart = () => ({
  type: competitionActionTypes.FETCH_CATEGORIES_START,
});

export const fetchCategoriesSuccess = (categories) => ({
  type: competitionActionTypes.FETCH_CATEGORIES_SUCCESS,
  payload: categories,
});

export const fetchCategoriesFailure = (error) => ({
  type: competitionActionTypes.FETCH_CATEGORIES_FAILURE,
  payload: error,
});

export const fetchSupportedGamesStart = () => ({
  type: competitionActionTypes.FETCH_SUPPORTED_GAMES_START,
});

export const fetchSupportedGamesSuccess = (games) => ({
  type: competitionActionTypes.FETCH_SUPPORTED_GAMES_SUCCESS,
  payload: games,
});

export const fetchSupportedGamesFailure = (error) => ({
  type: competitionActionTypes.FETCH_SUPPORTED_GAMES_FAILURE,
  payload: error,
});

export const deleteCompetitionStart = (data) => ({
  type: competitionActionTypes.DELETE_COMPETITION_START,
  payload: data, // { token, type, id }
});

export const deleteCompetitionSuccess = (message) => ({
  type: competitionActionTypes.DELETE_COMPETITION_SUCCESS,
  payload: message,
});

export const deleteCompetitionFailure = (error) => ({
  type: competitionActionTypes.DELETE_COMPETITION_FAILURE,
  payload: error,
});

export const editCompetitionStart = (data) => ({
  type: competitionActionTypes.EDIT_COMPETITION_START,
  payload: data, // { token, type, id, updateData }
});

export const editCompetitionSuccess = (competition) => ({
  type: competitionActionTypes.EDIT_COMPETITION_SUCCESS,
  payload: competition,
});

export const editCompetitionFailure = (error) => ({
  type: competitionActionTypes.EDIT_COMPETITION_FAILURE,
  payload: error,
});

export const publishCompetitionStart = (data) => ({
  type: competitionActionTypes.PUBLISH_COMPETITION_START,
  payload: data, // { token, type, id, verifiedToStart }
});

export const publishCompetitionSuccess = (competition) => ({
  type: competitionActionTypes.PUBLISH_COMPETITION_SUCCESS,
  payload: competition,
});

export const publishCompetitionFailure = (error) => ({
  type: competitionActionTypes.PUBLISH_COMPETITION_FAILURE,
  payload: error,
});

export const clearCompetitionMessages = () => ({
  type: competitionActionTypes.CLEAR_COMPETITION_MESSAGES,
});

export const uploadCompetitionImagesStart = (data) => ({
  type: competitionActionTypes.UPLOAD_COMPETITION_IMAGES_START,
  payload: data, // { token, type, competitionId, coverImage, additionalImages }
});

export const uploadCompetitionImagesSuccess = (competition) => ({
  type: competitionActionTypes.UPLOAD_COMPETITION_IMAGES_SUCCESS,
  payload: competition,
});

export const uploadCompetitionImagesFailure = (error) => ({
  type: competitionActionTypes.UPLOAD_COMPETITION_IMAGES_FAILURE,
  payload: error,
});

export const clearCreatedCompetition = () => ({
  type: competitionActionTypes.CLEAR_CREATED_COMPETITION,
});

export const fetchPublicEventsStart = (
  token,
  eventType,
  page = 1,
  limit = 10,
) => ({
  type: competitionActionTypes.FETCH_PUBLIC_EVENTS_START,
  payload: { token, eventType, page, limit },
});

export const fetchPublicEventsSuccess = (events) => ({
  type: competitionActionTypes.FETCH_PUBLIC_EVENTS_SUCCESS,
  payload: events,
});

export const fetchPublicEventsFailure = (error) => ({
  type: competitionActionTypes.FETCH_PUBLIC_EVENTS_FAILURE,
  payload: error,
});

// Homepage dedicated challenge slice actions
export const fetchPublicChallengesStart = (token, page = 1, limit = 10) => ({
  type: competitionActionTypes.FETCH_PUBLIC_CHALLENGES_START,
  payload: { token, page, limit },
});
export const fetchPublicChallengesSuccess = (data) => ({
  type: competitionActionTypes.FETCH_PUBLIC_CHALLENGES_SUCCESS,
  payload: data,
});
export const fetchPublicChallengesFailure = (error) => ({
  type: competitionActionTypes.FETCH_PUBLIC_CHALLENGES_FAILURE,
  payload: error,
});

// Homepage dedicated 1v1 slice actions
export const fetchPublicOneVOnesStart = (token, page = 1, limit = 10) => ({
  type: competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_START,
  payload: { token, page, limit },
});
export const fetchPublicOneVOnesSuccess = (data) => ({
  type: competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_SUCCESS,
  payload: data,
});
export const fetchPublicOneVOnesFailure = (error) => ({
  type: competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_FAILURE,
  payload: error,
});

// Challenge Ladder Actions
export const fetchChallengeLadderStart = (data) => ({
  type: competitionActionTypes.FETCH_CHALLENGE_LADDER_START,
  payload: data, // { token, challengeId }
});

export const fetchChallengeLadderSuccess = (ladder) => ({
  type: competitionActionTypes.FETCH_CHALLENGE_LADDER_SUCCESS,
  payload: ladder,
});

export const fetchChallengeLadderFailure = (error) => ({
  type: competitionActionTypes.FETCH_CHALLENGE_LADDER_FAILURE,
  payload: error,
});

// Challenge Winner Management
export const submitChallengeWinnerStart = (data) => ({
  type: competitionActionTypes.SUBMIT_CHALLENGE_WINNER_START,
  payload: data, // { token, pairId, winnerId, winnerName }
});

export const submitChallengeWinnerSuccess = (result) => ({
  type: competitionActionTypes.SUBMIT_CHALLENGE_WINNER_SUCCESS,
  payload: result,
});

export const submitChallengeWinnerFailure = (error) => ({
  type: competitionActionTypes.SUBMIT_CHALLENGE_WINNER_FAILURE,
  payload: error,
});

export const verifyChallengeWinnerStart = (data) => ({
  type: competitionActionTypes.VERIFY_CHALLENGE_WINNER_START,
  payload: data, // { token, pairId }
});

export const verifyChallengeWinnerSuccess = (result) => ({
  type: competitionActionTypes.VERIFY_CHALLENGE_WINNER_SUCCESS,
  payload: result,
});

export const verifyChallengeWinnerFailure = (error) => ({
  type: competitionActionTypes.VERIFY_CHALLENGE_WINNER_FAILURE,
  payload: error,
});

export const advanceChallengeRoundStart = (data) => ({
  type: competitionActionTypes.ADVANCE_CHALLENGE_ROUND_START,
  payload: data, // { token, challengeId }
});

export const advanceChallengeRoundSuccess = (result) => ({
  type: competitionActionTypes.ADVANCE_CHALLENGE_ROUND_SUCCESS,
  payload: result,
});

export const advanceChallengeRoundFailure = (error) => ({
  type: competitionActionTypes.ADVANCE_CHALLENGE_ROUND_FAILURE,
  payload: error,
});

// Challenge Lifecycle Management
export const verifyChallengeStart = (data) => ({
  type: competitionActionTypes.VERIFY_CHALLENGE_START,
  payload: data, // { token, challengeId }
});

export const verifyChallengeSuccess = (challenge) => ({
  type: competitionActionTypes.VERIFY_CHALLENGE_SUCCESS,
  payload: challenge,
});

export const verifyChallengeFailure = (error) => ({
  type: competitionActionTypes.VERIFY_CHALLENGE_FAILURE,
  payload: error,
});

export const commenceChallengeStart = (data) => ({
  type: competitionActionTypes.COMMENCE_CHALLENGE_START,
  payload: data, // { token, challengeId }
});

export const commenceChallengeSuccess = (challenge) => ({
  type: competitionActionTypes.COMMENCE_CHALLENGE_SUCCESS,
  payload: challenge,
});

export const commenceChallengeFailure = (error) => ({
  type: competitionActionTypes.COMMENCE_CHALLENGE_FAILURE,
  payload: error,
});

export const endChallengeStart = (data) => ({
  type: competitionActionTypes.END_CHALLENGE_START,
  payload: data, // { token, challengeId }
});

export const endChallengeSuccess = (challenge) => ({
  type: competitionActionTypes.END_CHALLENGE_SUCCESS,
  payload: challenge,
});

export const endChallengeFailure = (error) => ({
  type: competitionActionTypes.END_CHALLENGE_FAILURE,
  payload: error,
});

// Unsubscribe from competition
export const unsubscribeCompetitionStart = (data) => ({
  type: competitionActionTypes.UNSUBSCRIBE_COMPETITION_START,
  payload: data, // { token, type, id }
});

export const unsubscribeCompetitionSuccess = (result) => ({
  type: competitionActionTypes.UNSUBSCRIBE_COMPETITION_SUCCESS,
  payload: result,
});

export const unsubscribeCompetitionFailure = (error) => ({
  type: competitionActionTypes.UNSUBSCRIBE_COMPETITION_FAILURE,
  payload: error,
});

export const clearChallengeLadder = () => ({
  type: competitionActionTypes.CLEAR_CHALLENGE_LADDER,
});
